import { render, staticRenderFns } from "./BikesViewTable.vue?vue&type=template&id=1948d647&scoped=true&lang=pug&"
import script from "./BikesViewTable.vue?vue&type=script&lang=js&"
export * from "./BikesViewTable.vue?vue&type=script&lang=js&"
import style0 from "./BikesViewTable.vue?vue&type=style&index=0&id=1948d647&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948d647",
  null
  
)

export default component.exports